import { ChannelKeyValues, UserStatus } from '@app/shared';

export function splitArrayIntoChunks(data: Array<any>, chunkSize: number) {
    let res: Array<any> = [];
    data.forEach((item: object, i) => {
      const chunk = i%chunkSize===0 ? data.slice(i, i + chunkSize) : [];
      if (chunk.length > 0) {
        res.push(chunk);
      }
    });
    return res;
}


export function paginationHelper(pageSizeOptions: Array<any>, dataLength: any) {
  if (dataLength !== undefined) {
    if (dataLength <= 20) {
      return pageSizeOptions.filter(size => size <= 20);
    } else if (dataLength <= 50) {
      return pageSizeOptions.filter(size => size <= 50);
    } else {
      return pageSizeOptions;
    }
  }

  return [pageSizeOptions[0]];
}


export function shortenNumber(data: any): string {
  const value = parseInt(data);

  if (value >= 1000) {
    const suffixes = ["", "k", "M", "B", "T"];
    const suffixNum = Math.floor(("" + value).length / 3);
    let shortValue = parseFloat((suffixNum != 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(2));
    if (shortValue % 1 !== 0) {
        shortValue = Number(shortValue.toFixed(1));
    }
  
    const result = shortValue + suffixes[suffixNum]
    return result.toString();
  }

  return value.toString();
}


export function eventStatusHelper(eventStatus: any) {
  const status = eventStatus.toLowerCase();
  const failed = ['failed', 'undelivered'];

  if (failed.includes(status)) {
    return 'Failed';
  }

  return 'Sent';
}


export function dateFormatter(rawDate: any){
  const date = new Date(rawDate);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const formattedDate = `${month}/${day}`;

  return formattedDate;
}

export function formatChannel(channel: string){
  return channel?.split(',').map(word => {
    const words = word.trim().split(' ');
    const capitalizedWords = words.map(w => {
        if (w.toUpperCase() === ChannelKeyValues.sms) {
            return ChannelKeyValues.sms;
        } else {
            return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
        }
    });
    return capitalizedWords.join(' ');
  }).join(', ');
}

export function formatUserStatus(status: boolean) {
  if (status) {
    return UserStatus.yes;
  }

  return UserStatus.no;
}

export function roundToNearest(value: number) {
  const length = value.toString().length;
  
  let nearest;
  if (length <= 3) {
      nearest = 100;
  } else if (length <= 4) {
      nearest = 1000;
  } else {
      return value;
  }
  
  return Math.round(value / nearest) * nearest;
}

export function getErrorType(error: any): string {
  if (!error || error.status === undefined) {
    return 'UNKNOWN_ERROR';
  }

  const errorTypeMap: Record<number, string> = {
    0: 'NETWORK_ERROR',
    400: 'BAD_REQUEST',
    401: 'UNAUTHORIZED',
    403: 'FORBIDDEN',
    404: 'NOT_FOUND',
    409: 'CONFLICT',
  };

  return (
    errorTypeMap[error.status] ??
    (error.status >= 500 ? 'SERVER_ERROR' : 'UNKNOWN_ERROR')
  );
}